import { Icon } from '../../components/Icon';
import {
  RAIL_ICON,
  RAIL_ITEM_IDLE_BG,
  RAIL_ITEM_IDLE_TEXT,
  RAIL_ITEM_OPEN_BG,
  RAIL_ITEM_OPEN_TEXT,
  railItem,
  railItemFill,
  railLabel,
  sheetItem,
} from '../../components/railItem';
import { useRailCollapsed } from '../../lib/railCollapse';
import { openHelp, toggleHelp, useHelp, warmHelp } from './open';

/**
 * The two places help is opened by pointer.
 *
 * ── UNDER THE HAIRLINE, NOT IN THE LIST OF PLACES ────────────────────────────────────────────
 *
 * Help is not a destination: it opens over whatever page you are on, and what it shows first is
 * about that page. That puts it under the rail's hairline with the other application chrome. It
 * is a ROW there, with a label, rather than a third square beside the bell — three controls across
 * the expanded rail squeezed the account button until it could not show a name.
 */

/** The rail's Help row. Wears the rail's one control geometry, like the Search row at the top. */
export function HelpRailItem() {
  const { open } = useHelp();
  const [collapsed] = useRailCollapsed();

  return (
    <button
      type="button"
      onClick={toggleHelp}
      onPointerEnter={warmHelp}
      onFocus={warmHelp}
      aria-expanded={open}
      // Collapsed, there is no label, and the tooltip is the only thing that names it.
      title={collapsed ? 'Help and guides' : undefined}
      data-state={open ? 'open' : 'closed'}
      className={`${railItem(collapsed)} ${RAIL_ITEM_IDLE_TEXT} ${RAIL_ITEM_OPEN_TEXT}`}
    >
      <span
        aria-hidden="true"
        className={`${railItemFill(collapsed)} ${RAIL_ITEM_IDLE_BG} ${RAIL_ITEM_OPEN_BG}`}
      />
      <Icon name="help" size={RAIL_ICON} className="relative shrink-0" />
      <span className={railLabel(collapsed)}>Help</span>
    </button>
  );
}

/**
 * The same thing in the phone's More sheet, at the sheet's 44px touch geometry. The sheet closes
 * first — two overlays open at once is glass on glass (§2b).
 */
export function HelpSheetItem({ onNavigate }: { onNavigate: () => void }) {
  return (
    <button
      type="button"
      onClick={() => {
        onNavigate();
        openHelp();
      }}
      className={sheetItem()}
    >
      <Icon name="help" size={18} className="shrink-0" />
      Help and guides
    </button>
  );
}
